
// 是否支持区域内模式
export const SUPPORT_INNEAR_MODE = {
  YES: 1, // 支持
  NO: 0 // 不支持
}

// 是否支持枢纽站模式
export const SUPPORT_HUB_MODE = {
  YES: 1, // 支持
  NO: 0 // 不支持
}

// 是否开启一键叫车
export const ON_KEY_CALL = {
  ENABLE: 1, // 开启
  DISABLE: 0 // 关闭
}

// 区域模式
export const AREA_MODE = {
  INNEAR: 0, // 区域内模式（原始模式）
  HUB: 1 // 枢纽站模式
}

export const AREA_DIR = {
  TO_HUB: 0, // 往枢纽站方向
  FROM_HUB: 1, // 从枢纽站出发
}


export const AREA_TICKET_TYPE = {
  REALTIME_ORDER: 0, // 实时单
  BOOKING_ORDER: 1 // 预约单
}